/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { Box, Chip, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    fontWeight: 'bold',
    letterSpacing: 0.5,
    lineHeight: 1,
    paddingBottom: '0.2rem',
  },
}));

export type TagsProps = {
  tagArray: Array<any>;
  tagLimit?: number;
  tagTextLimit?: number;
};

export function Tags(props: TagsProps) {
  const { tagArray, tagLimit = 0 } = props;
  const classes = useStyles(props);
  const remainingTagsLength = tagArray.length - tagLimit;
  const remainingTags = tagArray.slice(0, tagLimit);
  if (tagLimit && remainingTagsLength > 0) {
    return (
      <Box>
        <Typography
          style={{ marginBottom: '4px' }}
          variant="body2"
          className={classes.label}
        >
          Tags
        </Typography>
        {remainingTags?.map(tag => (
          <Chip size="small" label={tag} key={tag} />
        ))}
        +{remainingTagsLength}
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        style={{ marginBottom: '4px' }}
        variant="body2"
        className={classes.label}
      >
        Tags
      </Typography>
      {tagArray?.map(tag => (
        <Chip size="small" label={tag} key={tag} />
      ))}
    </Box>
  );
}
